import { render, staticRenderFns } from "./DeliveryInfo.vue?vue&type=template&id=38b7634c&scoped=true"
import script from "./DeliveryInfo.vue?vue&type=script&lang=ts"
export * from "./DeliveryInfo.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryInfo.vue?vue&type=style&index=0&id=38b7634c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../nhaphangtocdo/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b7634c",
  null
  
)

export default component.exports